import { render, staticRenderFns } from "./homePageB.vue?vue&type=template&id=45cb763f&scoped=true&"
import script from "./homePageB.vue?vue&type=script&lang=js&"
export * from "./homePageB.vue?vue&type=script&lang=js&"
import style0 from "./homePageB.vue?vue&type=style&index=0&id=45cb763f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cb763f",
  null
  
)

export default component.exports